// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7964) return "static/chunks/7964-1c587b803456cd31.js";
	if (chunkId === 3778) return "static/chunks/a344ff8e-dca470b4bcb80dd0.js";
	if (chunkId === 7425) return "static/chunks/7425-94dc4d2240054213.js";
	if (chunkId === 7927) return "static/chunks/7927-87e962330fe45c26.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1468":"7788c30773c92445","3565":"3f186ce0a8d6336d","3973":"bace747f24a4a315","4703":"f9a403b038874979","5582":"b8fcd7b621bba878"}[chunkId] + ".js";
};